<template>
  <div class="q-mt-md">
    <div class="row items-center q-col-gutter-sm">
      <div class="col">
        <div class="text-h6">Диагностика отчета</div>
      </div>
      <div class="col-auto">
        <q-chip dense color="info" text-color="white">Информация: {{ counts.info }}</q-chip>
        <q-chip dense color="warning" text-color="dark">Предупреждения: {{ counts.warning }}</q-chip>
        <q-chip dense color="negative" text-color="white">Ошибки: {{ counts.error }}</q-chip>
      </div>
    </div>

    <q-banner v-if="!supported" dense rounded class="bg-grey-2 q-mt-sm">
      Диагностика для этого отчета недоступна.
    </q-banner>

    <q-banner v-else-if="diagnostics.length === 0" dense rounded class="bg-positive text-white q-mt-sm">
      Ошибок и предупреждений нет.
    </q-banner>

    <q-list v-else bordered separator class="q-mt-sm">
      <q-expansion-item
        v-for="item in diagnostics"
        :key="diagnosticKey(item)"
        :icon="iconFor(item.level)"
        :label="item.message || item.code || 'Сообщение диагностики'"
        :caption="formatDiagnosticLevel(item.level)"
        :header-class="headerClass(item.level)"
      >
        <div class="q-pa-md">
          <div v-if="item.code" class="text-caption text-grey-7 q-mb-sm">
            Код: {{ item.code }}
          </div>
          <div v-if="item.source">
            <div class="text-caption text-grey-7">Источник</div>
            <div>
              {{ item.source.document_type || 'Документ' }}
              <q-btn
                v-if="documentRoute(item.source)"
                flat
                dense
                color="primary"
                icon="open_in_new"
                label="Открыть документ"
                @click="$router.push(documentRoute(item.source))"
              />
            </div>
          </div>
        </div>
      </q-expansion-item>
    </q-list>
  </div>
</template>

<script>
import { formatDiagnosticLevel } from '../utils/reportFormatters'

export default {
  name: 'ReportDiagnostics',
  props: {
    diagnostics: {
      type: Array,
      default: () => []
    },
    supported: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    counts() {
      return this.diagnostics.reduce((acc, item) => {
        const level = item.level || 'info'
        if (acc[level] === undefined) {
          acc[level] = 0
        }
        acc[level] += 1
        return acc
      }, { info: 0, warning: 0, error: 0 })
    }
  },
  methods: {
    formatDiagnosticLevel,
    diagnosticKey(item) {
      return `${item.level || 'info'}-${item.code || ''}-${item.message || ''}`
    },
    iconFor(level) {
      if (level === 'error') {
        return 'error'
      }
      if (level === 'warning') {
        return 'warning'
      }
      return 'info'
    },
    headerClass(level) {
      if (level === 'error') {
        return 'text-negative'
      }
      if (level === 'warning') {
        return 'text-orange-9'
      }
      return 'text-primary'
    },
    documentRoute(source) {
      if (!source || !source.document_id) {
        return null
      }
      if (source.document_type === 'upd' || source.document_type === 'sale' || source.document_type === 'purchase') {
        return { name: 'document_info_upd', params: { id: source.document_id, history_id: 'last' } }
      }
      if (source.document_type === 'payment') {
        return { name: 'document_info_payment', params: { id: source.document_id, history_id: 'last' } }
      }
      if (source.document_type === 'factura_avance') {
        return { name: 'document_info_factura_avance', params: { id: source.document_id, history_id: 'last' } }
      }
      return null
    }
  }
}
</script>
